/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import ToolTip from 'material/message/tooltip/tooltip';
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/message/tip/tip_styles';



/* ========== ~~~~~~~~~~ TIP ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const Tip = (props) => {
	return (
		<span className={`tip ${props.classes.tip} space-${props.space}`}>
			<ToolTip position={`top`} action={`mouseenter`} content={props.content}>
				<Icon name={props.icon ? props.icon : `question-circle`} />
			</ToolTip>
		</span>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Tip);